module.exports = __webpack_public_path__ + "static/500_Virtual World Tour Mirosite-aed6cfa83398493c55042704ff90e07c.mp4";